import MuiCheckbox from '@mui/material/Checkbox';
import { forwardRef } from 'react';
import { Props } from './types';
import { StyledCheckbox, StyledIntermittentCheckbox } from './styles';
import CONFIG from './config';

const Checkbox = forwardRef<HTMLButtonElement, Props>(
  ({ size = CONFIG.DEFAULT_SIZE, disabled, ...otherProps }, ref) => {
    return (
      <MuiCheckbox
        {...otherProps}
        ref={ref}
        size={size}
        disabled={disabled}
        checkedIcon={
          <StyledCheckbox
            size={size}
            disabled={disabled}
          />
        }
        indeterminateIcon={
          <StyledIntermittentCheckbox
            size={size}
            disabled={disabled}
          />
        }
      />
    );
  },
);

Checkbox.displayName = 'Checkbox';

export default Checkbox;
